if (!window.BACKEND_CONFIG) {
  throw new Error(
    'CDK config is not available. Please check your configuration.'
  );
}

const cdkConfig = window.BACKEND_CONFIG;

export default cdkConfig;
